import { useEffect, useState } from 'react'
import { useLang } from '../../../../../../../language'
import { Alert } from 'react-bootstrap'
import { useForm } from '../../../../../../../hooks/useForm'
import { useValidator } from '../../../../../../../hooks/useValidator'
import { getValuesParams, isStatusSucess } from '../../../../../../../helpers/helpers'
import { ModalStatusServer } from '../../../../../../../components/Modals/ModalStatusServer'
import { TableTarifas } from './TableTarifas'
import { LoaderForm } from '../LoaderForm'
import { TarifasServices } from '../controllers/services/tarifas.service'

export const Tarifas = ({ formData = {}, idaparato, fetchAparatoGETData }: any) => {

    const Lang = useLang()

    const [formValuesSearch, handleInputChangeSearch, handleFormChangeSearch, resetformValuesSearch] = useForm({
        page: 1,
        limit: '',
        order: '',
        idserviciolinea: '',
        fecharegistrodesde: '',
        fecharegistrohasta: '',
        solo_pendientes: '',
    });

    const [excluidos, setExcluidos] = useState([])
    const [incluidos, setIncluidos] = useState([])

    const [checkAll, setCheckAll] = useState(false)


    const [formDatosGenerales, handleInputDatosGenerales, handleFormDatosGenerales, resetDatosGenerales] = useForm({
        // ...InformacionAdicionalAdapters.GET.receive.schema({}),
    })

    const [valuesValidationEvento, handleValidationEvento, handleResetValidationEvento] = useValidator({
        descripcion: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })

    const [fetchTarifasGET, fetchTarifasGETData] = TarifasServices.GET(idaparato)

    useEffect(() => {

        fetchTarifasGET()

    }, [])

    useEffect(() => {

        if (isStatusSucess(fetchTarifasGETData.status)) {

            handleFormDatosGenerales({
                ...fetchTarifasGETData.data
            })
        }
    }, [fetchTarifasGETData])


    // // --------------- PATCH Evento

    // const [fetchInscripcionPATCH, fetchInscripcionPATCHData] = InformacionAdicionalServices.PATCH()

    // const handleSubmitEditar = () => {

    //     if (handleValidationEvento(formDatosGenerales)) {
    //         fetchInscripcionPATCH({
    //             id: formDatosGenerales.id,
    //             body: {
    //                 ...formDatosGenerales,
    //             }
    //         })
    //     }

    //     // resetDatosGenerales()
    // }

    // useEffect(() => {

    //     if (isStatusSucess(fetchInscripcionPATCHData.status)) {

    //         resetDatosGenerales()

    //         fetchTarifasGET()
    //     }
    // }, [fetchInscripcionPATCHData])


    const handleEditorChange = (name: string, content: any) => {

        const target = {
            name,
            value: content,
        }

        handleInputDatosGenerales({ target })
    }

    const [dataExcluidos, setdataExcluidos] = useState([])

    return (
        <div>
            {
                (fetchTarifasGETData.loading || fetchAparatoGETData.loading) ?
                    <div className='card p-3 mt-3 '>
                        <LoaderForm />
                    </div>
                    :
                    <>
                        {
                            fetchAparatoGETData?.data?.gratuito !== 'true' ?

                                <div className="row mt-3 mb-3">

                                    <div className="col-12">
                                        <TableTarifas
                                            data={fetchTarifasGETData.data?.items}
                                            loading={fetchTarifasGETData.loading}
                                            total={fetchTarifasGETData.data?.total}
                                            perPage={fetchTarifasGETData.data?.per_page}

                                            formValuesSearch={formValuesSearch}
                                            handleFormChange={handleFormChangeSearch}
                                            handleInputChangeSearch={handleInputChangeSearch}
                                            setdataExcluidos={setdataExcluidos}

                                            checkAll={checkAll}
                                            setCheckAll={setCheckAll}
                                            setIncluidos={setIncluidos}
                                            setExcluidos={setExcluidos}
                                            excluidos={excluidos}
                                            incluidos={incluidos}
                                            urlParams={getValuesParams(formValuesSearch)}
                                            fetchTarifasGET={fetchTarifasGET}
                                            idaparato={idaparato}
                                        />

                                    </div>

                                </div>
                                :
                                <Alert variant='info' className='mt-3 text-center'>
                                    Només podeu afegir tarifes a un esdeveniment no gratuït
                                </Alert>
                        }
                    </>

            }

            {/* <ModalStatusServer fetchData={fetchInscripcionPATCHData} /> */}

        </div>
    )
}
